module.exports = __webpack_public_path__ + "img/手推车.29080bd4.png";